import React from 'react';
import { Notification } from 'tstypes';

import { SHeader, SName, SContainer, SDescription, STime } from './styled';

interface Props {
  notification: Notification;
}

const NotificationItem = ({ notification }: Props) => (
  <SContainer isActive={notification.unread}>
    <SHeader>
      <SName>{notification.verb}</SName>

      <STime format="HH:mm" timestamp={notification.created_at} />
    </SHeader>

    <SDescription>{notification.description}</SDescription>
  </SContainer>
);

export default NotificationItem;
